import { render, staticRenderFns } from "./AsyncList.vue?vue&type=template&id=4c4d2b6d&scoped=true"
import script from "./AsyncList.vue?vue&type=script&lang=js"
export * from "./AsyncList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d2b6d",
  null
  
)

export default component.exports